import { SVGAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const ThreeDTourIcon = ({ className, ...props }: SVGAttributes<SVGElement>) => (
  <svg
    data-cy="3d-tour-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    fill="none"
    className={twMerge('h-5 w-5 stroke-current', className)}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      d="M12 23V9.5m0 0L1 5.2m11 4.2 11-4.2m0 0c-.1-.2-.3-.3-.4-.3L12.3.9a.8.8 0 0 0-.6 0L1.4 5l-.4.2-.1.6v12.5a.9.9 0 0 0 .5.8l10.3 4h.6l10.3-4a.9.9 0 0 0 .5-.8V5.7l-.1-.6Z"
    />
  </svg>
)
